import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse, LabelPrintContextTypeDto, LabelPrinterDto, LabelPrinterPrintLogCreateDto, LabelTypeDto } from 'dtos'

export const LABEL_TYPE_IMPORTER_DOOR_ID = 1
export const LABEL_TYPE_CLUSTER_CONVERT_ID = 2
export const LABEL_TYPE_CLUSTER_PROGRAMMING_ID = 3
export const LABEL_TYPE_WINDOW_ID = 4
export const LABEL_TYPE_KEY_TAG_ID = 5

export const LABEL_PRINT_CONTEXT_TYPE_VEHICLE_CHECK_IN_ID = 1
export const LABEL_PRINT_CONTEXT_TYPE_VEHICLE_DETAILS_ID = 2

export const getActiveLabelPrinters = () =>
  apiClient.get<ApiResponse<LabelPrinterDto[]>>('/api/label-printing/label-printers').then(response => response.data)

export const getLabelTypes = () =>
  apiClient.get<ApiResponse<LabelTypeDto[]>>('/api/label-printing/label-types').then(response => response.data)

export const getLabelPrintContextTypes = () =>
  apiClient
    .get<ApiResponse<LabelPrintContextTypeDto[]>>('/api/label-printing/label-print-context-types')
    .then(response => response.data)

export const loadBluetoothLabelPrintingConfig = async () => {
  const [activeLabelPrintersResponse, labelTypesResponse, labelPrintContextTypesResponse] = await Promise.all([
    getActiveLabelPrinters(),
    getLabelTypes(),
    getLabelPrintContextTypes()
  ])

  const activeLabelPrinters = activeLabelPrintersResponse.value ?? []
  const labelTypeGuidById = new Map<number, string>()
  const labelPrintContextTypeGuidById = new Map<number, string>()

  for (const labelType of labelTypesResponse.value ?? []) {
    if (labelType.labelTypeId != null && labelType.labelTypeGuid) {
      labelTypeGuidById.set(labelType.labelTypeId, labelType.labelTypeGuid)
    }
  }

  for (const labelPrintContextType of labelPrintContextTypesResponse.value ?? []) {
    if (labelPrintContextType.labelPrintContextTypeId != null && labelPrintContextType.labelPrintContextTypeGuid) {
      labelPrintContextTypeGuidById.set(
        labelPrintContextType.labelPrintContextTypeId,
        labelPrintContextType.labelPrintContextTypeGuid
      )
    }
  }

  return {
    activeLabelPrinters,
    labelTypeGuidById,
    labelPrintContextTypeGuidById
  }
}

export const recordLabelPrinterPrintLog = (dto: LabelPrinterPrintLogCreateDto) =>
  apiClient.post<ApiResponse<boolean>>('/api/label-printing/label-printer-print-logs', dto).then(response => response.data)

export const getImporterDoorLabel = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient
    .get<ArrayBuffer>(`/api/label-printing/vehicles/${encodeURIComponent(vehicleGuid)}/labels/importer-door-label`, {
      cancelToken,
      responseType: 'arraybuffer'
    })
    .then(response => new Uint8Array(response.data))

export const getClusterConversionLabel = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient
    .get<ArrayBuffer>(`/api/label-printing/vehicles/${encodeURIComponent(vehicleGuid)}/labels/cluster-conversion-label`, {
      cancelToken,
      responseType: 'arraybuffer'
    })
    .then(response => new Uint8Array(response.data))

export const getClusterProgrammingLabel = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient
    .get<ArrayBuffer>(`/api/label-printing/vehicles/${encodeURIComponent(vehicleGuid)}/labels/cluster-programming-label`, {
      cancelToken,
      responseType: 'arraybuffer'
    })
    .then(response => new Uint8Array(response.data))

export const getWindowLabel = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient
    .get<ArrayBuffer>(`/api/label-printing/vehicles/${encodeURIComponent(vehicleGuid)}/labels/window-label`, {
      cancelToken,
      responseType: 'arraybuffer'
    })
    .then(response => new Uint8Array(response.data))

export const getKeyTagLabel = (vehicleGuid: string, cancelToken?: CancelToken) =>
  apiClient
    .get<ArrayBuffer>(`/api/label-printing/vehicles/${encodeURIComponent(vehicleGuid)}/labels/key-tag-label`, {
      cancelToken,
      responseType: 'arraybuffer'
    })
    .then(response => new Uint8Array(response.data))
